import React from 'react';
import appStyles from '../App.module.scss';
import { log } from '../lib/logger';
import styles from './Graph.module.scss';
import { useResourceBundle } from '../contexts/ResourceContext';

const Graph = ({ labelHeader, labelText, graph }: { graph: string; labelHeader: string; labelText: string }) => {
    const resource = useResourceBundle();

    const orderCallText = resource['label.bookCall.Text'];
    const orderCallUrl = resource['label.bookCall.Url'];
    const header = resource[labelHeader];
    let text = resource[labelText];

    if (!text) {
        throw new Error('Unknown label: ' + labelText);
    }

    log('Order a call text: ' + orderCallText);
    log('Order a call URL: ' + orderCallUrl);
    log('Src text: ' + text);

    // "label.graph.text.open.mon": "You might want to ###ORDER-A-CALL###."
    const parts = text.split(/###ORDER-A-CALL###/);
    const textPart1 = parts.shift();
    const textPart2 = parts.shift();

    log('Dst text: ' + text);

    return (
        <div className="Box Box--spot">
            <header className={styles.header}>
                <h3 className={appStyles['Box-header']}>{header}</h3>
            </header>
            <p>
                {textPart1}
                <a className="link" href={orderCallUrl}>
                    {orderCallText}
                </a>
                {textPart2}
            </p>
            <img src={graph} alt="" />
        </div>
    );
};

export default Graph;
